import {Injectable} from "@angular/core";
import {CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot} from "@angular/router";
import {AuthentService} from "./services/authent.service";
import {UserService} from "./services/data/user.service";
import {UrlService} from "./services/url.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authentService: AuthentService, private router: Router,
              private userService: UserService, private urlService: UrlService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.authentService.getToken() != null) {
      if (this.authentService.getUser() == null) {

        this.userService.getPrincipal().subscribe(user => {
            user.avatarUrl = this.urlService.getMemberAvatarUrl(user.id);
            this.authentService.setUser(user);
            return true;
          },
          error => {
            console.log(error);
          });

      } else {
        return true;
      }

    } else {
      this.router.navigate(['/']);
    }
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/auth-guard.service.ts